import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let CommonSettingsModal = class CommonSettingsModal extends Vue {
    constructor() {
        super(...arguments);
        this.isRefreshOn = true;
    }
    get intervalInMinute() {
        return this.interval / 60000;
    }
    created() {
        this.isRefreshOn = this.isRefreshEnabled;
    }
    resultRetrieved() {
        this.$emit('modalClosed');
    }
    refreshChanged() {
        this.$emit('refreshChanged', this.isRefreshOn);
    }
};
__decorate([
    Prop({ type: Boolean })
], CommonSettingsModal.prototype, "isRefreshEnabled", void 0);
__decorate([
    Prop({ type: Number })
], CommonSettingsModal.prototype, "interval", void 0);
CommonSettingsModal = __decorate([
    Component({})
], CommonSettingsModal);
export default CommonSettingsModal;
